import type { FaireProductEntity } from "../../entity_types/product";

export const p_arva9x9wjd: FaireProductEntity = {
  token: "p_arva9x9wjd",
  type: "product",
  name: "Playful Squiggle Brass Band Ring",
  brandToken: "b_6jbk8zuc",
  brandName: "Amsha",
  imageUrl: "https://cdn.faire.com/fastly/28e26b3b778d78d9ae757e7a6ef6399cde7e51c9bcaf725a65640dbca7dfc5da.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1d594e2f73f89b625ae577880d32264d3cdcb7fbf67c594c46fd7d3fc9408771.jpeg",
    "https://cdn.faire.com/fastly/c522f09ff7e4f966f0285005ba26e4f1430aad47fdfc5e1aa29d4c4f45ed2dd4.jpeg",
    "https://cdn.faire.com/fastly/405fa39759ee008ffe888034d86aa861f3f286136b6d1b5a8f7d0329d4e9455a.jpeg"
  ],
  priceDollars: 6,
  description: "There is beauty in simplicity.\n\nA playful, squiggle brass wire ring. Fun on every finger!",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:15.305Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
